import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import A4ImageWithExpandable from "../../components/A4ImageWithExpandable/A4ImageWithExpandable.js";
import { fetchImages } from "../../services/imageService";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner.js";

const Announcements = () => {
  const [currentImage, setCurrentImage] = useState(null);
  const [pastImages, setPastImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentDate, setCurrentDate] = useState(null);

  useEffect(() => {
    loadAnnouncements();
  }, []);

  const loadAnnouncements = async () => {
    setLoading(true);
    const images = await fetchImages('ogloszenia');
    
    if (images && images.length > 0) {
      const sortedImages = [...images].sort((a, b) => 
        new Date(b.createdAt) - new Date(a.createdAt)
      );
      
      setCurrentImage(sortedImages[0]);
      setCurrentDate(new Date(sortedImages[0].createdAt));
      
      const pastImagesUrls = sortedImages.slice(1).map(img => img.url);
      setPastImages(pastImagesUrls);
    } else {
      setCurrentImage(null);
      setPastImages([]);
      setCurrentDate(null);
    }
    
    setLoading(false);
  };

  const formattedDate = currentDate 
    ? currentDate.toLocaleDateString('pl-PL', { year: 'numeric', month: 'long', day: 'numeric' })
    : '';

  if (loading) {
    return (
      <>
        <Helmet>
          <title>Ogłoszenia parafialne – Parafia św. Urszuli Ledóchowskiej</title>
          <meta name="description" content="Aktualne ogłoszenia parafialne – sprawdź najnowsze informacje i komunikaty z naszej parafii. Ogłoszenia duszpasterskie na bieżący tydzień." />
          <meta property="og:title" content="Ogłoszenia parafialne – Parafia św. Urszuli Ledóchowskiej" />
          <meta property="og:description" content="Sprawdź aktualne ogłoszenia duszpasterskie. Informacje o mszach, nabożeństwach i wydarzeniach w parafii." />
        </Helmet>
        <section className="announcements-loading">
          <LoadingSpinner />
        </section>
      </>
    );
  }

  if (!currentImage) {
    return (
      <>
        <Helmet>
          <title>Ogłoszenia parafialne – Parafia św. Urszuli Ledóchowskiej</title>
          <meta name="description" content="Brak aktualnych ogłoszeń parafialnych. Zapraszamy do sprawdzenia później lub kontaktu z kancelarią parafialną." />
          <meta property="og:title" content="Ogłoszenia parafialne – Parafia św. Urszuli Ledóchowskiej" />
          <meta property="og:description" content="Aktualne ogłoszenia parafialne wkrótce. Zapraszamy do śledzenia strony." />
        </Helmet>
        <section className="announcements-empty">
          <p>Brak aktualnych ogłoszeń</p>
        </section>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>Ogłoszenia parafialne – Parafia św. Urszuli Ledóchowskiej</title>
        <meta name="description" content={`Aktualne ogłoszenia parafialne z dnia ${formattedDate}. Sprawdź najnowsze komunikaty, informacje o mszach, nabożeństwach i wydarzeniach w parafii św. Urszuli Ledóchowskiej w Częstochowie.`} />
        <meta name="keywords" content="ogłoszenia parafialne, ogłoszenia duszpasterskie, komunikaty parafialne, św. Urszula Ledóchowska, Częstochowa" />
        <meta property="og:title" content={`Ogłoszenia parafialne – ${formattedDate}`} />
        <meta property="og:description" content={`Aktualne ogłoszenia duszpasterskie z dnia ${formattedDate}. Informacje o mszach, nabożeństwach i wydarzeniach w parafii.`} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={currentImage.url} />
        <meta property="og:image:alt" content="Ogłoszenia parafialne" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`Ogłoszenia parafialne – ${formattedDate}`} />
        <meta name="twitter:description" content={`Aktualne ogłoszenia parafialne z dnia ${formattedDate}. Sprawdź na stronie parafii św. Urszuli Ledóchowskiej.`} />
        <meta name="twitter:image" content={currentImage.url} />
      </Helmet>

      <section>
        <A4ImageWithExpandable
          mainImage={currentImage.url}
          expandedImage={pastImages}
          linkLabel="Ogłoszenia - poprzednie tygodnie"
          currentImageDate={new Date(currentImage.createdAt).toLocaleDateString('pl-PL')}
        />
      </section>
    </>
  );
};

export default Announcements;